import React from "react";
import Image from "apps/website/components/base/Image/Image";
import LandingPageRecipeCarousel from "apps/website/components/feature/Carousel/LandingPageRecipeCarousel/LandingPageRecipeCarousel";
import {
  recipeCarouselData,
} from "apps/website/components/feature/Carousel/LandingPageRecipeCarousel/shared/recipeCarouselData";

interface IRecipeContentProps {
  imageKey: string;
}

export const RecipeContent: React.FC<IRecipeContentProps> = ({ imageKey }) => (
  <div className="flex flex-col xl:flex-row items-center justify-center gap-4 px-2">
    <div className="w-full xl:w-1/3 flex justify-center">
      <Image
        image={{
          src: `/images/landingPage/sectionRecipeComparison/${imageKey.toLowerCase()}.webp`,
          width: 744,
          height: 720,
        }}
        alt={`Image of ${imageKey}`}
      />
    </div>
    <div className="w-full xl:w-2/3">
      <LandingPageRecipeCarousel items={recipeCarouselData} className="bg-white" />
    </div>
  </div>
);
